import React, { useState,useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
  Divider,

  Menu,
  MenuItem
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth,firestore } from "../../../firebaseConfig"; // Import the Firebase auth module
import { doc, getDoc } from "firebase/firestore";
import { deepOrange } from "@mui/material/colors";
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import LogoutIcon from '@mui/icons-material/Logout';
import GavelIcon from "@mui/icons-material/Gavel"; // Import Terms icon
import SettingsIcon from "@mui/icons-material/Settings"; // Import the Settings icon
import Headerimg from "./Header.png"


const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [user, setUser] = useState(null); // Store user details
  const [userName, setUserName] = useState(null); // Store Firestore name

  const [anchorEl, setAnchorEl] = useState(null); // For controlling dropdown menu
  const open = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget); // Open menu when avatar is clicked
  };

  const handleClose = () => {
    setAnchorEl(null); // Close menu
  };
  

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser); // Set Firebase auth user data

        // Fetch user details from Firestore
        const userDocRef = doc(firestore, "users", currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUserName(userData.name); // Set the name from Firestore
        }
      } else {
        setUser(null);
        setUserName(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener on unmount
  }, []);


  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null); // Clear user data on logout
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  // Drawer content for mobile navigation
  const drawerContent = (
    <Box
      sx={{
        width: 250,
        backgroundColor: "#f9f9f9",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "16px",
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontFamily: "'Work Sans', sans-serif",
          letterSpacing: "1.2px",
          marginBottom: "16px",
          color: "#2C3E50",
        }}
      >
        Stock101
      </Typography>
      <Divider sx={{ marginBottom: "16px" }} />
      <List>
        {[
          { text: "Home", path: "/" },
          { text: "NYSE Stock Screener", path: "/screener" },
          { text: "Ranking", path: "/ranking_news" },
          { text: "Prize Target", path: "/prize_target_news" },
          { text: "Trending", path: "/trending_news" },
          { text: "Login", path: "/login" },
        ].map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.path}
              sx={{
                padding: "12px 16px",
                borderRadius: "8px",
                ":hover": {
                  backgroundColor: "#E5F2FF",
                  color: "#007bff",
                },
              }}
            >
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  fontSize: "15px",
                  fontFamily: "'Work Sans', sans-serif",
                  fontWeight: 500,
                  color: "#2C3E50",
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  // Desktop header design
  const desktopHeader = (
    <AppBar
    position="static"
    sx={{
      backgroundColor: "#ffffff",
      color: "#2C3E50",
      boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
      padding: "0 32px",
    }}
  >
    <Toolbar
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "72px",
      }}
    >
      {/* Logo */}
      <Typography
        variant="h5"
        component="div"
        sx={{
          fontWeight: 700,
          fontFamily: "'Work Sans', sans-serif",
          letterSpacing: "1.5px",
        }}
      >
        Stock101
      </Typography>

      {/* Navigation links */}
      <Box sx={{ display: "flex", gap: "24px" }}>
        {[
          { text: "Home", path: "/" },
          { text: "NYSE Stock Screener", path: "/screener" },
          { text: "Ranking", path: "/ranking_news" },
          { text: "Prize Target", path: "/prize_target_news" },
          { text: "Trending", path: "/trending_news" },
        ].map((item) => (
          <Button
            key={item.text}
            component={Link}
            to={item.path}
            sx={{
              fontSize: "15px",
              fontFamily: "'Work Sans', sans-serif",
              textTransform: "none",
              color: "#2C3E50",
              fontWeight: 500,
              ":hover": { color: "#007bff" },
            }}
          >
            {item.text}
          </Button>
        ))}
      </Box>

      {/* Login/Avatar */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        {user ? (
          <>
            <IconButton onClick={handleAvatarClick}>
              <Avatar sx={{ bgcolor: deepOrange[500] }}>
                {userName
                  ? userName.charAt(0).toUpperCase()
                  : "U"}
              </Avatar>
            </IconButton>
            <Menu
  anchorEl={anchorEl}
  open={open}
  onClose={handleClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "center",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "center",
  }}
  sx={{
    borderRadius: "8px", // Rounded corners
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Subtle shadow
    overflow: "hidden",
    "& .MuiPaper-root": {
      borderRadius: "8px",
      padding: "4px 0", // Reduce padding for compact styling
    },
  }}
>
  <MenuItem
    onClick={handleClose}
    component={Link}
    to="/ManageSubscription"
    sx={{
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "15px",
      color: "#2C3E50",
      padding: "10px 16px",
      transition: "background-color 0.2s ease, color 0.2s ease",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        color: "#007bff", // Accent color on hover
      },
    }}
  >
    <SubscriptionsIcon
      sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }}
    />
    Manage Subscription
  </MenuItem>
  <MenuItem
    onClick={handleClose}
    component={Link}
    to="/Contactus"
    sx={{
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "15px",
      color: "#2C3E50",
      padding: "10px 16px",
      transition: "background-color 0.2s ease, color 0.2s ease",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        color: "#007bff", // Accent color on hover
      },
    }}
  >
    <ContactMailIcon
      sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }}
    />
    Contact Us
  </MenuItem>
  <MenuItem
                onClick={handleClose}
                component={Link}
                to="/terms"
                sx={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontSize: "15px",
                  color: "#2C3E50",
                  padding: "10px 16px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    color: "#007bff",
                  },
                }}
              >
                <GavelIcon sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }} />
                Terms & Conditions
              </MenuItem>
  <MenuItem
    onClick={() => {
      handleClose();
      handleLogout();
    }}
    sx={{
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "15px",
      color: "#2C3E50",
      padding: "10px 16px",
      transition: "background-color 0.2s ease, color 0.2s ease",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        color: "#d9534f", // Red accent for sign out
      },
    }}
  >
    <LogoutIcon
      sx={{ fontSize: "18px", marginRight: "8px", color: "#d9534f" }}
    />
    Sign Out
  </MenuItem>
</Menu>
          </>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              component={Link}
              to="/login"
              variant="outlined"
              sx={{
                fontSize: "14px",
                textTransform: "none",
                borderColor: "#007bff",
                color: "#007bff",
                borderRadius: "20px",
                padding: "6px 16px",
                ":hover": {
                  backgroundColor: "#007bff",
                  color: "#ffffff",
                },
              }}
            >
              Login
            </Button>
            <IconButton
              onClick={handleAvatarClick}
              sx={{
                marginLeft: "10px", // Adding space between the login button and settings icon
              }}
            >
              <SettingsIcon sx={{ color: "#007bff" }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              sx={{
                borderRadius: "8px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
                "& .MuiPaper-root": {
                  borderRadius: "8px",
                  padding: "4px 0",
                },
              }}
            >
  <MenuItem
    onClick={handleClose}
    component={Link}
    to="/Contactus"
    sx={{
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "15px",
      color: "#2C3E50",
      padding: "10px 16px",
      transition: "background-color 0.2s ease, color 0.2s ease",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        color: "#007bff", // Accent color on hover
      },
    }}
  >
    <ContactMailIcon
      sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }}
    />
    Contact Us
  </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to="/terms"
                sx={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontSize: "15px",
                  color: "#2C3E50",
                  padding: "10px 16px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    color: "#007bff",
                  },
                }}
              >
                <GavelIcon sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }} />
                Terms & Conditions
              </MenuItem>
            </Menu>
          </div>
        )}
      </Box>
    </Toolbar>
  </AppBar>
  );

  // Mobile header with Drawer
  const mobileHeader = (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#ffffff",
          color: "#2C3E50",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "72px",
            padding: "0 16px",
          }}
        >
          {/* Mobile menu icon */}
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
            sx={{ color: "#2C3E50" }}
          >
            <MenuIcon sx={{ fontSize: "28px" }} />
          </IconButton>
  
          {/* Logo */}
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 700,
              fontFamily: "'Work Sans', sans-serif",
              letterSpacing: "1.2px",
            }}
          >
            Stock101
          </Typography>
  
          {/* Login/Avatar */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {user ? (
              <>
                <IconButton onClick={handleAvatarClick}>
                  <Avatar sx={{ bgcolor: deepOrange[500] }}>
                    {userName ? userName.charAt(0).toUpperCase() : "U"}
                  </Avatar>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  sx={{
                    borderRadius: "8px", // Rounded corners
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Subtle shadow
                    overflow: "hidden",
                    "& .MuiPaper-root": {
                      borderRadius: "8px",
                      padding: "4px 0", // Reduce padding for compact styling
                    },
                  }}
                >
                  <MenuItem
                    onClick={handleClose}
                    component={Link}
                    to="/subscription"
                    sx={{
                      fontFamily: "'Work Sans', sans-serif",
                      fontSize: "15px",
                      color: "#2C3E50",
                      padding: "10px 16px",
                      transition: "background-color 0.2s ease, color 0.2s ease",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        color: "#007bff", // Accent color on hover
                      },
                    }}
                  >
                    <SubscriptionsIcon
                      sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }}
                    />
                    Manage Subscription
                  </MenuItem>
                  <MenuItem
                    onClick={handleClose}
                    component={Link}
                    to="/contact"
                    sx={{
                      fontFamily: "'Work Sans', sans-serif",
                      fontSize: "15px",
                      color: "#2C3E50",
                      padding: "10px 16px",
                      transition: "background-color 0.2s ease, color 0.2s ease",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        color: "#007bff", // Accent color on hover
                      },
                    }}
                  >
                    <ContactMailIcon
                      sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }}
                    />
                    Contact Us
                  </MenuItem>
                  <MenuItem
                onClick={handleClose}
                component={Link}
                to="/terms"
                sx={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontSize: "15px",
                  color: "#2C3E50",
                  padding: "10px 16px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    color: "#007bff",
                  },
                }}
              >
                <GavelIcon sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }} />
                Terms & Conditions
              </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      handleLogout();
                    }}
                    sx={{
                      fontFamily: "'Work Sans', sans-serif",
                      fontSize: "15px",
                      color: "#2C3E50",
                      padding: "10px 16px",
                      transition: "background-color 0.2s ease, color 0.2s ease",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        color: "#d9534f", // Red accent for sign out
                      },
                    }}
                  >
                    <LogoutIcon
                      sx={{ fontSize: "18px", marginRight: "8px", color: "#d9534f" }}
                    />
                    Sign Out
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  component={Link}
                  to="/login"
                  variant="outlined"
                  sx={{
                    fontSize: "14px",
                    textTransform: "none",
                    borderColor: "#007bff",
                    color: "#007bff",
                    borderRadius: "20px",
                    padding: "6px 16px",
                    ":hover": {
                      backgroundColor: "#007bff",
                      color: "#ffffff",
                    },
                  }}
                >
                  Login
                </Button>
                <IconButton
                  onClick={handleAvatarClick}
                  sx={{
                    marginLeft: "10px", // Adding space between the login button and settings icon
                  }}
                >
                  <SettingsIcon sx={{ color: "#007bff" }} />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  sx={{
                    borderRadius: "8px",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    overflow: "hidden",
                    "& .MuiPaper-root": {
                      borderRadius: "8px",
                      padding: "4px 0",
                    },
                  }}
                >
      <MenuItem
        onClick={handleClose}
        component={Link}
        to="/Contactus"
        sx={{
          fontFamily: "'Work Sans', sans-serif",
          fontSize: "15px",
          color: "#2C3E50",
          padding: "10px 16px",
          transition: "background-color 0.2s ease, color 0.2s ease",
          "&:hover": {
            backgroundColor: "#f5f5f5",
            color: "#007bff", // Accent color on hover
          },
        }}
      >
        <ContactMailIcon
          sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }}
        />
        Contact Us
      </MenuItem>
                  <MenuItem
                    onClick={handleClose}
                    component={Link}
                    to="/terms"
                    sx={{
                      fontFamily: "'Work Sans', sans-serif",
                      fontSize: "15px",
                      color: "#2C3E50",
                      padding: "10px 16px",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        color: "#007bff",
                      },
                    }}
                  >
                    <GavelIcon sx={{ fontSize: "18px", marginRight: "8px", color: "#007bff" }} />
                    Terms & Conditions
                  </MenuItem>
                </Menu>
              </div>
            )}
          </Box>
        </Toolbar>
      </AppBar>
  
      {/* Drawer for mobile navigation */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
  

  return isMobile ? mobileHeader : desktopHeader;
};

export default Header;
